import { styled } from '@mui/material/styles';
import { Accordion } from '@mui/material';
import { renderTypographyStyles } from '../../../../../base/utils';

export const StyledWrapperMenuDesktop = styled('div')(
  ({ theme }) => ` 
     ${theme.breakpoints.down('lg')} {
      display: none;
    }
  `,
);

export const StyledAccordion = styled(Accordion)(
  ({ theme }) => `
    .MuiAccordionSummary-root {
      min-height: ${theme.DS_spacing(['xlx'])};
    }
    
    .MuiAccordionSummary-content {
      text-transform: uppercase;
      margin: 10px 0;
    }
    
    .MuiAccordionSummary-expandIconWrapper {
      svg {
        width: 12px;
        height: 12px;
      }
    }
    
    .MuiCollapse-root {
      width: 100%;
  
      .MuiAccordionDetails-root {
        display: flex;
        flex-flow: column nowrap;
        color: ${theme.DS_palette.primary.black};
      }
    }
    
    ${theme.breakpoints.up('lg')} {
      display: none;
    }
  `,
);

export const StyledAccordionListItem = styled('div')(
  ({ theme }) => `
    padding: ${theme.DS_spacing(['xs'])} 0;
    :first-of-type {
      margin-top: 0;
    }
    :last-of-type {
      margin-bottom: ${theme.DS_spacing(['xs'])};
    }
    a {
      color: ${theme.DS_palette.text.primary};
      ${renderTypographyStyles(theme.typography.DS_labelSmallRegular)};
    }
  `,
);

export const StyledDesktopMenuList = styled('ul')(
  ({ theme }) => `
    margin-top: ${theme.DS_spacing(['md'])};
    display: flex;
    flex-direction: column;
    gap: ${theme.DS_spacing(['md'])};
    
    a {
      color: ${theme.DS_palette.text.primary};
    }
  `,
);
